<template>
  <el-dialog :title="$t('repairPoolManage.end')" :visible.sync="visible" width="650px" custom-class="repair-design-dialog" @close="resetForm">
    <el-form ref="form" :model="formData" label-width="86px" class="repair-dialog-form">
      <el-form-item label="结束原因" prop="context" :rules="[{ required: true, message: '请输入结束原因', trigger: 'blur' }]">
        <el-input v-model="formData.context" placeholder="请输入" />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer repair-dialog-footer">
      <el-button class="dialog-cancel-btn" @click="visible = false">取消</el-button>
      <el-button type="primary" class="dialog-submit-btn" @click="submitForm">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { endRepair } from '@/api/work/repairPoolManageApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'EndRepair',
  data() {
    return {
      visible: false,
      formData: {
        repairId: '',
        communityId: '',
        context: ''
      }
    }
  },
  methods: {
    open(repair) {
      this.formData.repairId = repair.repairId
      this.formData.communityId = repair.communityId || getCommunityId()
      this.visible = true
    },

    async submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            const data = {
              ...this.formData,
              communityId: this.formData.communityId
            }

            await endRepair(data)
            this.$message.success(this.$t('common.operationSuccess'))
            this.visible = false
            this.$emit('success')
          } catch (error) {
            console.error('End repair failed:', error)
            this.$message.error(error.message || error)
          }
        }
      })
    },

    resetForm() {
      this.$refs.form.resetFields()
      this.formData = {
        repairId: '',
        communityId: '',
        context: ''
      }
    }
  }
}
</script>

<style scoped>
.repair-dialog-form { padding: 8px 24px 0; }
.repair-dialog-form >>> .el-form-item { margin-bottom: 24px; }
.repair-dialog-form >>> .el-form-item__label { color: #1D2129; font-weight: 400; white-space: nowrap; }
.repair-dialog-form >>> .el-input__inner { height: 38px; border-radius: 8px; border-color: #DCE6F5; }
.repair-dialog-footer { display: flex; justify-content: flex-end; gap: 12px; }
.dialog-cancel-btn, .dialog-submit-btn { width: 74px; height: 38px; padding: 0; border-radius: 10px; }
.dialog-cancel-btn { color: #0E76FF; border-color: #0E76FF; background: #fff; }
.dialog-submit-btn { background: #0E76FF; border-color: #0E76FF; }
</style>
